import React, { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";

const PDContestWinners = () => {
    const authState = useSelector((state) => state.authReducer);
    const [fetchData] = useFetch();

    const userId = authState?.user?._id;
    const token = authState?.token;

    const [records, setRecords] = useState([]);
    const [selected, setSelected] = useState(null);

    const hasFetchedRef = useRef(false);

    // ---------------- FILTER STATES ----------------
    const [search, setSearch] = useState("");
    const [userCodeFilter, setUserCodeFilter] = useState("");
    const [contestFilter, setContestFilter] = useState("");

    const fetchList = async () => {
        if (!userId || !token) return;

        try {
            const res = await fetchData({
                url: "/pd/contest/winners",
                method: "post",
                // data: {
                //     contestResultDate: new Date() 
                // },
                headers: { Authorization: token }
            });

            if (res?.success) {
                setRecords(res.data || []);
                hasFetchedRef.current = true;
            }
        } catch (err) {
            console.error("PDContestWinners error:", err);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    // ---------------- FILTER LOGIC ----------------
    // const filteredRecords = useMemo(() => {
    //     return (records || []).filter((item) => {
    //         const searchText = search.toLowerCase();

    //         const matchSearch =
    //             !searchText ||
    //             item.userName?.toLowerCase().includes(searchText) ||
    //             item.rewardTitle?.toLowerCase().includes(searchText) ||
    //             item.contestName?.toLowerCase().includes(searchText);

    //         const matchUserCode =
    //             !userCodeFilter ||
    //             item.userCode?.toLowerCase().includes(userCodeFilter.toLowerCase());

    //         const matchContest =
    //             !contestFilter ||
    //             item.contestName?.toLowerCase().includes(contestFilter.toLowerCase());

    //         return matchSearch && matchUserCode && matchContest;
    //     });
    // }, [records, search, userCodeFilter, contestFilter]);

    const clearFilters = () => {
        setSearch("");
        setUserCodeFilter("");
        setContestFilter("");
    };

    return (
        <div className="space-y-3 pt-3 border-t-2 border-cyan-200 rounded-xl">
            {/* <div className="bg-[#0f172a] border border-gray-600 rounded-xl p-3 space-y-2">
                <div className="text-xs text-cyan-300 font-bold">
                    🏆 Filter Contest Winners
                </div>

                <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search user, reward, contest..."
                    className="w-full bg-gray-900 text-white p-2 rounded text-xs"
                />

                <div className="grid grid-cols-2 gap-2">
                    <input
                        value={userCodeFilter}
                        onChange={(e) => setUserCodeFilter(e.target.value)}
                        placeholder="User Code"
                        className="bg-gray-900 text-white p-2 rounded text-xs"
                    />

                    <input
                        value={contestFilter}
                        onChange={(e) => setContestFilter(e.target.value)}
                        placeholder="Contest Name"
                        className="bg-gray-900 text-white p-2 rounded text-xs"
                    />
                </div>

                <button
                    onClick={clearFilters}
                    className="text-[10px] text-cyan-300 underline"
                >
                    Clear Filters
                </button>
            </div> */}

            {/* ---------------- LIST ---------------- */}
            <div className="bg-[#111827] rounded-xl border border-gray-800">
                <div className="px-3 py-2 text-xs text-cyan-300 font-bold border-b border-gray-700">
                    🏆 Contest Winners ({records.length})
                </div>

                {records.map((item) => (
                    <div key={item._id} className="border-t border-gray-800 p-3">

                        <div
                            onClick={() => setSelected(item)}
                            className="cursor-pointer flex justify-between items-center"
                        >
                            <div>
                                <div className="text-xs font-semibold text-white">
                                    {item.userName || "Unknown User"}
                                </div>

                                <div className="text-[10px] text-gray-400">
                                    🆔 {item.userCode || "N/A"}
                                </div>
                            </div>

                            <div className="text-[10px] text-yellow-300">
                                {item.contestName || "Contest"}
                            </div>
                        </div>

                        {selected?._id === item._id && (
                            <div className="mt-3 bg-[#0f172a] p-4 rounded-lg border border-cyan-500/20 space-y-2">

                                {/* USER */}
                                <div className="text-sm font-bold text-white">
                                    {item.userName}
                                </div>

                                <div className="text-xs text-gray-300">
                                    🆔 User Code: {item.userCode}
                                </div>

                                {/* CONTEST */}
                                <div className="text-xs text-cyan-300">
                                    🏁 Contest: {item.contestName}
                                </div>

                                <div className="text-[10px] text-gray-400">
                                    📅 From: {new Date(item.contestromDate).toLocaleDateString("en-IN")}
                                </div>

                                <div className="text-[10px] text-gray-400">
                                    📅 To: {new Date(item.contestToDate).toLocaleDateString("en-IN")}
                                </div>

                                <div className="text-[10px] text-yellow-300">
                                    🏆 Result Date: {new Date(item.contestResultDate).toLocaleDateString("en-IN")}
                                </div>

                                {/* REWARD */}
                                <div className="text-xs text-green-400 font-semibold">
                                    🎁 {item.rewardTitle}
                                </div>

                                <div className="text-[10px] text-gray-300">
                                    {item.rewardDetails}
                                </div>

                                {/* REMARKS */}
                                {item.remarks && (
                                    <div className="text-[10px] text-gray-400">
                                        📝 {item.remarks}
                                    </div>
                                )}

                                {/* STATUS */}
                                <div className="text-[10px] text-cyan-400">
                                    {item.isActive ? "🟢 Active" : "🔴 Inactive"}
                                </div>

                                {/* CREATED */}
                                <div className="text-[10px] text-gray-500">
                                    📌 Created: {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                </div>

                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PDContestWinners;